import toast from 'react-hot-toast';
import { agentApi } from '@/services/agentApi';
import { ApplicationDocument } from '@/utils/applicationDocuments';

export function ExistingDocumentLink({ applicationId, document }: { applicationId?: number | null; document: ApplicationDocument }) {
  const download = async () => {
    if (!applicationId) return;
    try {
      const blob = await agentApi.downloadApplicationDocument(applicationId, Number(document.id));
      const url = URL.createObjectURL(blob);
      const anchor = window.document.createElement('a');
      anchor.href = url;
      anchor.download = document.originalName || document.fileName || `Document ${document.id}`;
      anchor.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch { toast.error('Could not download document. Please try again.'); }
  };
  return <button type="button" className="btn btn-link btn-sm p-0" onClick={download}>{document.originalName || document.fileName || `Document ${document.id}`}</button>;
}
